// frontend/src/components/common/ErrorMessage.js
import React from "react";
import "./ErrorMessage.css";

const ErrorMessage = ({ message, onRetry }) => {
  return (
    <div className="error-container">
      <div className="error-content">
        <p className="error-message">{message}</p>
        {onRetry && (
          <button onClick={onRetry} className="error-button">
            Retry
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
